import {createApp} from "vue";

createApp({
    data: function () {
        return {
            errors: [],
            message: {
                name: null,
                email: null,
                phone: null,
                content: null,
                recaptcha: null,
            },
            saving: false,
        }
    },
    methods: {
        save: function () {
            if (this.saving) {
                return;
            }

            this.saving = true;

            const payload = {
                message: this.message,
                recaptcha: grecaptcha.getResponse(),
            };

            const request = axios.post('/contact', payload);

            request.then((response) => {
                location.href = 'contact'
            }).catch((error) => {
                this.errors = parseAxiosError(error);
            }).then(() => {
                this.saving = false;
            });
        }
    }
}).mount('#contact-form');
